import { ReactText } from 'react'

export function isString (param: unknown): param is string {
  return typeof param === 'string'
}

export function isReactText (param: unknown): param is ReactText {
  return typeof param === 'number' || typeof param === 'string'
}
